import { useSnackbar } from 'notistack';
import React from 'react';
import { Close } from '@material-ui/icons';
import { IconButton, Button } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

/**
 *
 * @returns {notify}
 */
const useNotif = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const baseURL = window.location.origin;

  const success = (text, options = {}) => {
    enqueueSnackbar(text, { variant: 'success', ...options });
  };

  const info = (text, options = {}) => {
    enqueueSnackbar(text, { variant: 'info', ...options });
  };

  const warning = (text, options = {}) => {
    enqueueSnackbar(text, { variant: 'warning', ...options });
  };

  const error = (text, options = {}) => {
    enqueueSnackbar(text, { variant: 'error', ...options });
  };
  const custom = ({
    text = '',
    variant = '',
    path = '', // Extracted path variable directly from the payload blueprint
    notifKey = '',
    options = {}
  }) => {
    const showCloseButton =
      options.persist === true || options.closeButton === true;

    // Handles marking as read in the local storage list and routing
    const handleSnackbarClick = snackbarKey => {
      if (notifKey) {
        let stored = JSON.parse(localStorage.getItem('Notifications')) || {};
        if (stored[notifKey] && !stored[notifKey].read) {
          stored[notifKey].read = true;
          localStorage.setItem('Notifications', JSON.stringify(stored));
          window.dispatchEvent(new Event('Notifications'));
        }
      }

      // 2. Route safely if a path is present in the notification data
      if (path) {
        window.open(`${window.location.origin}/${path}`, '_blank');
      }

      // 3. Clear the snackbar from the screen
      closeSnackbar(snackbarKey);
    };

    const key = enqueueSnackbar(
      <span
        onClick={() => handleSnackbarClick(key)}
        style={{
          cursor: path ? 'pointer' : 'default',
          display: 'inline-block',
          width: '100%',
          paddingRight: showCloseButton ? '24px' : '0px'
        }}
      >
        {text !== '' && text}
      </span>,
      {
        variant: variant ?? 'info',
        action: showCloseButton
          ? snackbarKey => (
              <IconButton
                onClick={e => {
                  e.stopPropagation();
                  closeSnackbar(snackbarKey);
                }}
                style={{ padding: 4 }}
              >
                <Close style={{ color: 'white', fontSize: '1.2rem' }} />
              </IconButton>
            )
          : undefined,

        ...options
      }
    );
  };

  return { success, info, warning, error, custom };
};

export default useNotif;
